import { IIntervalService } from 'angular';
import { BehaviorSubject, Observable } from 'rxjs';

import { SocialNetworkModel } from '../model/social-network-model';

const MODULE_NAME = 'socialNetworkTabService';

export class SocialNetworkTabService {
  static $inject = ['$interval'];

  public name = MODULE_NAME;
  currentTime: number = Date.now();
  private _newConversationCount: number = 0;
  private _intervalHandler;

  private readonly _socialNetworkName$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private readonly _conversationCount$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private readonly _firstMessageTime$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private readonly _lastMessageDate$: BehaviorSubject<Date> = new BehaviorSubject<Date>(new Date());

  constructor(private $interval: IIntervalService) {}

  get socialNetworkName$(): Observable<string> {
    return this._socialNetworkName$.asObservable();
  }

  set socialNetworkName(socialNetworkName: string) {
    this._socialNetworkName$.next(socialNetworkName);
  }

  get conversationCount$(): Observable<number> {
    return this._conversationCount$.asObservable();
  }

  set conversationCount(conversationCount: number) {
    if (conversationCount !== this._conversationCount$.value) {
      this._conversationCount$.next(conversationCount);
    }

    if (conversationCount !== this._conversationCount$.value) {
      this._conversationCount$.next(conversationCount);
      if (conversationCount === 1) {
        this._intervalHandler = this.$interval(() => {
          this.currentTime = Date.now();
        }, 1000);
      } else {
        this.$interval.cancel(this._intervalHandler);
        this._intervalHandler = null;
      }
    }
  }

  get firstMessageTime$(): Observable<number> {
    return this._firstMessageTime$.asObservable();
  }

  set firstMessageTime(firstMessageTime: number) {
    this._firstMessageTime$.next(firstMessageTime);
  }

  get lastMessageDate$(): Observable<Date> {
    return this._lastMessageDate$.asObservable();
  }

  set lastMessageDate(date: Date) {
    if (!this._lastMessageDate$.value && this._lastMessageDate$.value > date) {
      return;
    }
    this._lastMessageDate$.next(date);
  }

  /**
   * Get the last message sent by a customer in the list of the available socialNetwork conversations
   * @param {Array<SocialNetworkModel>} socialNetworkList available socialNetwork conversations
   */
  computeLastMessageDateForAllSocialNetworks(socialNetworkList: Array<SocialNetworkModel>): void {
    const lastMessageDate = socialNetworkList.reduce((prev: number, socialNetwork: SocialNetworkModel) => {
      if (socialNetwork.tab.lastMessageTime && socialNetwork.tab.lastMessageTime > prev) {
        return socialNetwork.tab.lastMessageTime;
      } else {
        return prev;
      }
    }, 0);
    this._lastMessageDate$.next(new Date(lastMessageDate));
  }

  getNewConversationCount(): number {
    return this._newConversationCount;
  }

  setNewConversationCount(socialNetworkList: Array<SocialNetworkModel>): void {
    this._newConversationCount = 0;
    socialNetworkList.forEach(tab => {
      this._newConversationCount += tab.tab.newMessagesCount;
    });
  }

  incrementNewConversationCount(): void {
    this._newConversationCount++;
  }
}

export default MODULE_NAME;
